import { Directive } from '@angular/core';

@Directive({
  selector: '[appTableChange]'
})
export class TableChangeDirective {

  constructor() { }

}
